import React from 'react';

const AnalyzeContracts = () => <h1 className="pageTitle">Contracts</h1>;

export default AnalyzeContracts;
